<template>
  <div class="clients">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Licenses</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Licenses</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="serverParams.license_name"
                  type="text"
                  class="form-control floating"
                  @change="getLicenseList"
                />
                <label class="focus-label">License Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="serverParams.license_phone_number"
                  type="text"
                  class="form-control floating"
                  @change="getLicenseList"
                />
                <label class="focus-label">Phone Number</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <select v-model="serverParams.license_status" class="form-control">
                  <option value>Select Status</option>
                  <option v-bind:value="  'draft' ">Draft</option>
                  <option v-bind:value="  'active' ">Active</option>
                  <option v-bind:value="  'almost_expired'">Almost Expired</option>
                  <option v-bind:value="  'expired' ">Expired</option>
                </select>
                <label class="focus-label">Status</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">Lisensi</th>
                      <th class="text-center">No Whatsapp</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">Masa Aktif</th>
                      <th class="text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(rowArr,index) in rows" :key="index">
                        <td>{{rowArr.license_name}}</td>
                        <td>
                          <a
                            target="_blank"
                            :href="'https://api.whatsapp.com/send?phone='+rowArr.license_phone_number"
                          >{{rowArr.license_phone_number}}</a>
                        </td>
                        <td class="text-center">{{rowArr.license_email}}</td>
                        <td class="text-right">
                          <div v-if="rowArr.is_unlimited==1" class="small">
                            <span class="badge badge-info">UNLIMITED</span>
                          </div>
                          <div
                            v-else-if="rowArr.is_unlimited==0 && rowArr.status_label=='Active'"
                            class="small"
                          >
                            <span class="badge badge-info">ACTIVE</span>
                            <div
                              class="small text-info"
                            >Sisa masa aktif: {{timeAgo(convertUTCDatetimeToUnix(rowArr.license_masa_aktif+" 23:59:59"))}}</div>
                          </div>
                          <div v-else class="small text-danger">
                            <span
                              class="badge badge-danger"
                              v-if="rowArr.license_masa_aktif=='1990-01-01'"
                            >INACTIVE</span>
                            <span v-else>
                              EXPIRED
                              <div
                                class="small text-danger"
                              >{{timeAgo(convertUTCDatetimeToUnix(rowArr.license_masa_aktif+" 23:59:59"))}}</div>
                            </span>
                          </div>
                        </td>
                        <td class="text-center" :ref="'statusScan-'+rowArr.id">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length<1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="'btn '+{
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }"
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <!-- /edit client -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import {
  labelPackageProductEnglish,
  timeAgo,
  convertUTCDatetimeToUnix
} from "@/utils/helper";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect
  },
  data() {
    return {
      isLoading: false,
      licenseSelected: {
        id: "",
        is_unlimited: 0,
        license_create_datetime: "",
        license_email: "",
        license_key: "",
        license_last_send_datetime: "",
        license_name: "",
        license_network_id: 0,
        license_phone_number: "",
        license_update_datetime: "",
        status_label: "",
        tz: "Asia/Jakarta"
      },
      currentVoucherId: "",
      detailVoucher: null,
      formExtend: false,
      formNew: false,
      loading: false,
      listData: [],
      formCreate: {
        license_name: "",
        license_email: "",
        license_phone_number: ""
      },
      formUpdate: {
        id: "",
        license_name: "",
        license_email: "",
        license_phone_number: ""
      },
      paramLicense: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 1,
        perPage: 50 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    ...mapGetters(["fieldsGetLicenseList"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    }
  },
  async created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  filters: {
    labelPackageProductEnglish(value) {
      return labelPackageProductEnglish(value);
    }
  },
  methods: {
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    actExtendLicense() {
      if (this.licenseSelected.id == "") {
        this.$fire({
          title: "Error",
          text: "License ID is required!",
          type: "error",
          timer: 3000
        });
        return;
      }
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          //jika berhasil maka langsung extend license
          let param = {
            license_id: this.licenseSelected.id,
            voucher_id: this.currentVoucherId
          };
          this.$store.dispatch("order/extendLicense", param).then(resExt => {
            this.$fire({
              title: "Success",
              text: resExt["msg"],
              type: "success",
              timer: 3000
            }).then(async r => {
              // await document.getElementById("btnCloseCreateLicense").click(); // Click on the checkbox
              await document.getElementById("btnCloseExntedLicense").click(); // Click on the checkbox
              await this.getLicenseList();
            });
          });
        }
      });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    asyncFindLicense(query) {
      this.isLoading = true;
      this.paramLicense.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.paramLicense)
        .then(response => {
          console.log("response:: ", response);
          this.isLoading = false;
          this.listData = response.data.data;

          // console.log("query: ", query);
          // console.log("contactOptionsGroup: ", this.contactOptionsGroup);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    customLabelLicense({ license_name, license_phone_number }) {
      if (license_name == "") {
        return "";
      }
      return `${license_name} - ${license_phone_number}`;
    },
    getActiveVoucher(id) {
      this.detailVoucher = null;
      this.$store.dispatch("order/getActiveVoucher", id).then(response => {
        var { data } = response;
        this.detailVoucher = data;

        let action = this.$route.query.action;
        console.log("action", action);
        this.formNew = false;
        this.formExtend = false;
        if (typeof action != "undefined" && action != "") {
          if (action == "new") {
            this.formNew = true;
            this.formExtend = false;
            setTimeout(function() {
              document.getElementById("addBtn").click(); // Click on the checkbox
            }, 1000);
          } else if (action == "extend") {
            this.formNew = false;
            this.formExtend = true;
            setTimeout(function() {
              document.getElementById("extendBtn").click(); // Click on the checkbox
            }, 1000);
          }
        }
      });
    },
    async isOnline(licenseId, phone) {
      await this.$store
        .dispatch("omniwa/isOnline", phone)
        .then(response => {
          var { data } = response;
          // console.log("data.status", data);
          if (data === true) {
            this.$refs["statusScan-" + licenseId][0].innerHTML =
              '<label class="badge badge-success">Online</label>';
          } else {
            this.$refs["statusScan-" + licenseId][0].innerHTML =
              '<label class="badge badge-danger">Offline</label>';
          }
        })
        .catch(error => {});
    },
    async getLicenseById(id) {
      this.loading = await true;

      await this.$store
        .dispatch("license/getLicenseById", id)
        .then(response => {
          var { data } = response;
          this.formUpdate = data;

          //   console.log("response", response);
        });
      this.loading = await false;
    },
    async getLicenseList() {
      this.loading = await true;

      await this.$store
        .dispatch("license/getLicenseList", this.fieldsGetLicenseList)
        .then(response => {
          var { data } = response;
          this.listData = data.data;
          //   console.log("response", response);
          // this.listData.forEach((row, index) => {
          //   this.isOnline(row.id, row.license_phone_number);
          //   // console.log("row", row);
          //   // console.log("index", index);
          // });
        });
      this.loading = await false;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("license/getLicenseList", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // this.rows.forEach((row, index) => {
          //   this.isOnline(row.id, row.license_phone_number);
          //   // console.log("row", row);
          //   // console.log("index", index);
          // });
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  beforeDestroy() {
    this.fieldsGetLicenseList.license_status = "";
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "clients"
};
</script>


// WEBPACK FOOTER //
// src/views/license/list.vue